<template>
	<div id="app" :class="$route.name">

		<router-view v-if="!loading" />

		<modal v-show="$store.getters['core/errors'].length > 0" :isModalVisible="true" @clicked="closeModal" :largeModal="true">
			<h3 slot="headline"></h3>
			<p slot="text"><ul class="errorlist" v-for="(data, index) in $store.getters['core/errors']" :key="index" :id="index" :data="data">
				<li>{{ data }}</li>
			</ul>
			</p>
			<template slot="closeBtn">{{ $t('Schließen') }}</template>
		</modal>
		<div v-show="$store.getters['core/errors'].length > 0" @click="closeModal" class="modal-backdrop show"></div>

		<!-- <div class="lf-notices" ref="panelnotes">
			<div v-if="$store.getters['core/errors'].length > 0" class="margin-top-large margin-bottom-xlarge">
				<NoticeCard v-for="(data, index) in $store.getters['core/errors']" :key="index" :id="index" :data="data"></NoticeCard>
			</div>
		</div> -->

	</div>
</template>

<script>
export default {
	name: 'App',
	data() {
		return {
			loading: true,
			isModalVisible:false
		}
	},
	created(){
		var self = this;

		// aktiviere de als standart
    	this.$i18n.locale = 'de';

		this.$store.dispatch('orm/LOAD_ORM')
		.then(res => {
			// "lazy loading der übersetzungen"
			self.$i18n.setLocaleMessage('de', Object.assign({}, self.$i18n.messages['de'], self.$store.getters["orm/translations"]))
			self.loading = false;

			if(this.$store.getters['core/errors'].length > 0) this.isModalVisible = true ;

		});	

		let recaptchaScript = document.createElement('link')
	    recaptchaScript.setAttribute('href', process.env.API_URL+'/api/grav/override.css')
	    recaptchaScript.setAttribute('rel', 'stylesheet')
	    document.head.appendChild(recaptchaScript)
	},
	methods: {
		closeModal(value) {
      		switch (value) {
			  case 'close':
			  	this.$store.commit('core/REMOVE_ERRORS');
        		document.body.classList.remove("modal-open");
			  	break;
			  default:
			  	break;
			}        	
      	},
	}
}

</script>
<style lang="scss">
@import './styles/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue